module.exports = __webpack_public_path__ + "img/serotonin-thumbnail.6e5c13dd.png";